module.exports = __webpack_public_path__ + "img/logo copy.de17b37d.png";